import Vue from "vue";

let currantData = new Vue({
    data: {
        $successMessage: '',
        $errorMessage: '',
    },
});
Vue.mixin({
    computed: {
        $successMessage: {
            get: function () {
                return currantData.$data.$successMessage
            },
            set: function (data) {
                currantData.$data.$successMessage = data;
            }
        },
        $errorMessage: {
            get: function () {
                return currantData.$data.$errorMessage
            },
            set: function (data) {
                currantData.$data.$errorMessage = data;
            }
        },
    }
});